import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { PageFunctionType } from '@shared/core/analytics/telemetry/types';

const category = 'shippingAddress';
const pagePrefix = 'admin';
export type PagesForTelemetry = 'shippingAddressFormDialog' | 'reminderAddShippingAddressDialog';
const pages: { [tab in PagesForTelemetry]: PageFunctionType } = {
  shippingAddressFormDialog: ({ pageNameLocation }: { pageNameLocation?: string }) => ({
    category,
    pagePrefix,
    page: `AddShippingAddressDialog`,
    extraPageInfo: {
      from: pageNameLocation
    }
  }),
  reminderAddShippingAddressDialog: ({ pageNameLocation }: { pageNameLocation?: string }) => ({
    category,
    pagePrefix,
    page: `ReminderShippingAddressDialog`,
    extraPageInfo: {
      from: pageNameLocation
    }
  })
};

const shippingAddressTelemetry = createTelemetryObject({
  actions: {
    closeAddressDialog: () => ({
      category,
      action: 'ButtonInteracted',
      actionType: 'click',
      label: 'close address dialog'
    }),
    saveAddressClicked: () => ({
      category,
      action: 'ButtonInteracted',
      actionType: 'click',
      label: 'Save Address'
    }),
    verifyAddressClicked: (isValidated: boolean) => ({
      category,
      action: 'ButtonInteracted',
      actionType: 'click',
      label: 'Confirm Address',
      extraInfo: {
        isValidated
      }
    })
  },
  pages
});

const { TelemetryProvider, useTelemetry } = createTelemetry(shippingAddressTelemetry);
const useShippingAddressTelemetry = useTelemetry;
export { TelemetryProvider, useShippingAddressTelemetry };
